import React from "react";
import XiniuChat from "./sections/XiniuChat";
import Trends from "./sections/Trends";
import Benchmark from "./sections/Benchmark";

export default function Index() {
  return <>
    <XiniuChat />
    <Trends />
    <Benchmark />
  </>
}
